import React from 'react';
import PropTypes from 'prop-types';
import { Mutation } from '@apollo/client/react/components';
import Promise from 'bluebird';

import LikeButton from 'four-nets/photoblog/posts/common/like-button/like-button';
import { AuthOrigin } from 'four-nets/user/auth/auth-ga-events';

import likeMutation, { likeImageMutation, likeImageMutationVariables } from './like.graphql';
import unlikeMutation, { unlikeImageMutation, unlikeImageMutationVariables } from './unlike.graphql';
import { LikeUnlikeImageFragment } from './like-unlike-image.graphql';

interface Props extends LikeUnlikeImageFragment {
    like: (mutationFn: () => Promise<any>) => void;
    unlike: (mutationFn: () => Promise<any>) => void;
    inFeed?: boolean;
}

class LikeUnlikeImage extends React.PureComponent<Props> {
    static contextTypes = {
        authCheck: PropTypes.func,
    };
    render() {
        const { id, isLikedByViewer, like, unlike, inFeed } = this.props;

        return (
            <Mutation<likeImageMutation, likeImageMutationVariables> mutation={likeMutation}>
                {likeImage => (
                    <Mutation<unlikeImageMutation, unlikeImageMutationVariables> mutation={unlikeMutation}>
                        {unlikeImage => {
                            const onClick = () =>
                                this.context.authCheck(() => {
                                    if (isLikedByViewer) {
                                        return unlike(() => unlikeImage({ variables: { id } }) as any);
                                    } else {
                                        return like(() => likeImage({ variables: { id } }) as any);
                                    }
                                }, AuthOrigin.LikeImage);

                            return (
                                <LikeButton
                                    inFeed={inFeed}
                                    onTouchEnd={onClick}
                                    onClick={onClick}
                                    isLikedByViewer={Boolean(isLikedByViewer)}
                                />
                            );
                        }}
                    </Mutation>
                )}
            </Mutation>
        );
    }
}

export default LikeUnlikeImage;
